module.exports = __webpack_public_path__ + "static/media/sa.39ab155e.svg";